import { connect } from 'react-redux'
import { CookiesManagementComponent } from './CookiesManagementComponent'
import type { CookiesConsents } from 'shared/store/user'
import { consentCookies, displayManageCookies } from 'shared/store/user'
import cookiesDefinitions from 'shared/store/user/cookies-definitions'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => {
    const {
        cookiesConsents,
        cookiesConsentsDone,
        manageCookies
    } = state.userState
    const cookiesConsentsList = cookiesDefinitions.map(cookieDefinition => {
        let consent = cookiesConsents[cookieDefinition.id]
        consent = consent === undefined ? true : consent
        return {
            ...cookieDefinition,
            consent
        }
    })

    return {
        cookiesConsents: cookiesConsentsList,
        cookiesConsentsDone,
        manageCookies
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    consentCookies: (consents: CookiesConsents) => d(consentCookies(consents)),
    closeManageCookies: () => d(displayManageCookies(false))
})

const CookiesManagement = connect(
    mapStateToProps,
    mapDispatchToProps
)(CookiesManagementComponent)

export { CookiesManagement }
